import type { FaireProductEntity } from "../../entity_types/product";

export const p_zrdwx37ysx: FaireProductEntity = {
  token: "p_zrdwx37ysx",
  type: "product",
  name: "Soft Genuine Leather Baby Moccasins",
  brandToken: "b_wk94as365j",
  brandName: "Axesoria West",
  imageUrl: "https://cdn.faire.com/fastly/03875326071847e55ba748f62c8a1c349addfad238d2c41486231ae74ad82afe.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e8593607356624f300e3d3d247d3272795aff9adaa58126269141793afa58782.jpeg",
    "https://cdn.faire.com/fastly/80b6d692dca53ecbf06311135d65f0e720027101a7e1d24a13e8d879672c787b.jpeg",
    "https://cdn.faire.com/fastly/4fb46beb3c9c91acc1d3cacffa00ed0a55d399a0b7f98ac641b66dd3458a7e29.jpeg",
    "https://cdn.faire.com/fastly/c55741fdb8b3da80efebaa709f6883633db2b94c1579aa3d1bffc8d7a337e69a.jpeg",
    "https://cdn.faire.com/fastly/634262bf1514aa7f7ac8d686906805357b6bcd074bb7193a7feda6a2f1f18271.jpeg"
  ],
  priceDollars: 7.99,
  description: "Hand Made baby moccasins made by first steps brand at special price\n100% genuine soft pebble leather in cream or black\navailable in size 1 to 6. please refer to size chart for shoe length\nsoft leather sole\nComes with a Reusable Dust Bag ",
  tags: [],
  msrpDollars: 15.98,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:55:38.828Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
